const satisfactionSurveyCourse = [
    {
        "code": "TAF-QM110049",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/10/12~2021/10/14",
        "location": "線上",
    },
    {
        "code": "TAF-MH110002",
        "name": "醫學實驗室主管訓練",
        "classDate": "2021/10/20~2021/10/22",
        "location": "線上",
    }
];

export default satisfactionSurveyCourse;